<template>
  <div>
    <div class="content is-large">
      <h2>{{ name }}</h2>
      <h1>{{ step }}</h1>
    </div>
    <div class="content is-large">
      <h1>{{ minutes | padLeft }}:{{ seconds | padLeft }}</h1>
    </div>
    <progress class="progress is-primary" :value="percent" max="100" v-bind:class="progressClass">{{ percent }}%</progress>
    <div class="content">
      <p>{{ nextStep }}</p>
    </div>
    <div class="buttons is-centered">
      <button class="button is-success is-large" @click="onStart" v-show="!timer">
        <span class="icon"><i class="ion-md-play"></i></span>Start
      </button>
      <button class="button is-info" @click="onSkip" v-show="timer">
        <span class="icon"><i class="ion-md-skip-forward"></i></span>Skip
      </button>
    </div>
  </div>
</template>

<script>
import timerData from '@/assets/timer-data.json'

export default {
  data: () => ({
      name: '',
      step: '',
      timer: null,
      remaining: 0,
      color: 'success',
      index: 0,
      timerData: timerData
    }),
  methods: {
    onStart() {
      this.timer = setInterval(() => this.countdown(), 1000)
    },
    onSkip() {
      this.remaining = 0
    },
    countdown() {
      if (this.remaining > 0) {
        this.remaining--
        return
      }

      if (++this.index >= this.timerData.timers.length) {
        clearInterval(this.timer)
        this.timer = null
        this.index = 0
      }

      this.getNextTimer()
    },
    getNextTimer() {
      var nextTimer = this.timerData.timers[this.index]

      this.step = nextTimer.step
      this.remaining = nextTimer.seconds
      this.color = nextTimer.color
    }
  },
  computed: {
    minutes() {
      return Math.floor(this.remaining / 60)
    },
    seconds() {
      return this.remaining % 60
    },
    percent() {
      return 100 - this.remaining / this.timerData.timers[this.index].seconds * 100
    },
    nextStep() {
      if (!this.timer) {
        return null
      }

      if (this.index >= this.timerData.timers.length - 1) {
        return 'Almost done...'
      }

      return `Next up: ${this.timerData.timers[this.index + 1].step}`
    },
    progressClass() {
      return {
        'is-danger': this.color === 'danger',
        'is-warning': this.color === 'warning',
        'is-success': this.color === 'success'
      }
    }
  },
  filters: {
    padLeft (value) {
      return value < 10 ? `0${value}` : `${value}`
    }
  },
  mounted() {
    this.name = this.timerData.name
    this.getNextTimer()
  }
}
</script>

<style scoped>
  div {
    max-width: 500px;
  }

  .button .icon:first-child:last-child {
    margin-right: 0;
}
</style>
